import { Box, styled } from "@mui/material";

export const StyledInvoiceListHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  gap: ".5rem",
  paddingBottom: "1rem",
  paddingInline: ".5rem",
  boxSizing: "border-box",
  ".invoiceDate, .paymentDate": {
    width: "7.3%",
     boxSizing: "border-box",
  },
  ".ref": {
    width: "12%",
  },
  ".name": {
    width: "15%",
  },
  ".type": {
    width: "7.5%",
  },
  ".value": {
    width: "7.5%",
  },
  ".description": {
    width: "15%",
  },
  ".quarter": {
    width: "7.5%",
  },
  ".buttonWrapper": {
    width: "5%",
  },
  ".headerhead": {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    width: "100%",
    justifyContent: "space-between",
    h5: {
      fontWeight: "bold",
      textAlign: "center",
    },
    ".filterButtons": {
      cursor: "pointer",
      "&:hover": {
        fontWeight: "bold",
      },
    },
  },
  "& .MuiOutlinedInput-root": {
    border: "2px solid #333",
    borderRadius: "50px",
    maxWidth: "100%",
    width: "100%",
    minWidth: "100%",
    height: "2.5rem",
    overflow: "hidden",
    padding: "0",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    height: "100%",
    width: "100%",
  },
  "& .MuiAutocomplete-inputRoot": {
    display: "flex",
    justifyContent: "center",
    flexWrap: "nowrap",
    overflow: "hidden",
    paddingInline: "1rem",
  },
}));
